<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div>
    <section>
      <h5 class="pb-1 mb-0">Please enter the date and time for your slot</h5>
      <p class="text-danger">Please note that adhoc slots do not affect terminal stock and stats.</p>
      <p>Slots are up to {{max_slot_length}} minutes long. Calls are terminated when the slot ends.</p>
    </section>
    <section class="d-flex flex-wrap">
      <section class="full-width mb-2">
        <label>Booking Date</label>
        <b-form-datepicker
          :value="selectedBookingSlotDate"
          @input="setBookingSlotDate($event)"
          :min="minDate"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        />
      </section>
      <section class="slot-stage pr-5">
        <p>Start Time</p>

        <div class="clock-custom d-flex" style="font-size: 18pt">
          <div>
            <i @click="increaseTimeSlot('slotBeginHour', hours, updateEndSlot)" class="fas fa-chevron-up d-block"></i>
            <span class="d-block">{{bookingSlotToCreate.slotBeginHour}} :</span>
            <i @click="decreaseTimeSlot('slotBeginHour', hours, updateEndSlot)" class="fas fa-chevron-down d-block"></i>
          </div>

          <div class="ml-1">
            <i @click="increaseTimeSlot('slotBeginMin', mins, updateEndSlot)" class="fas fa-chevron-up d-block"></i>
            <span class="d-block">{{bookingSlotToCreate.slotBeginMin}}</span>
            <i @click="decreaseTimeSlot('slotBeginMin', mins, updateEndSlot)" class="fas fa-chevron-down d-block"></i>
          </div>
        </div>
      </section>
      <section class="slot-stage" v-if="!limitedSlot">
        <p>End Time</p>

        <div class="clock-custom d-flex" style="font-size: 18pt">
          <div>
            <i @click="increaseTimeSlot('slotEndHour', hours, checkEndSlotValid)" class="fas fa-chevron-up d-block"></i>
            <span class="d-block">{{bookingSlotToCreate.slotEndHour}} :</span>
            <i @click="decreaseTimeSlot('slotEndHour', hours, checkEndSlotValid)" class="fas fa-chevron-down d-block"></i>
          </div>

          <div class="ml-1">
            <i @click="increaseTimeSlot('slotEndMin', mins, checkEndSlotValid)" class="fas fa-chevron-up d-block"></i>
            <span class="d-block">{{bookingSlotToCreate.slotEndMin}}</span>
            <i @click="decreaseTimeSlot('slotEndMin', mins, checkEndSlotValid)" class="fas fa-chevron-down d-block"></i>
          </div>
        </div>
      </section>
    </section>
    <section>
      <p class="red mt-1" v-if="!endDateValid">Please change the slot time so it is within the {{max_slot_length}} minute duration</p>

      <p class="mt-2 mb-2 font-weight-bold">
        This slot will start at: <b>{{bookingSlotToCreate.slotBeginHour}}:{{bookingSlotToCreate.slotBeginMin}}</b>
        <span class="px-1 d-inline-block">and end at: <b>{{bookingSlotToCreate.slotEndHour}}:{{bookingSlotToCreate.slotEndMin}}</b></span>
      </p>
    </section>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import {mapState} from 'vuex';
  import moment from 'moment';
  import BookingSlotService from '@/services/BookingSlotService';

  export default {
    components: {},
    props: {},
    computed: mapState({
      limitedSlot: state => state.prison.limitedSlot,
      max_slot_length: state => state.prison.max_slot_length,
      selectedBookingSlotDate: state => state.booking.selectedBookingSlotDate,
      endDateValid: state => state.booking.endDateValid,
    }),
    data() {
      return {
        minDate: moment().format('YYYY-MM-DD'),
        hours: BookingSlotService.getHours(),
        mins: BookingSlotService.getMinutes(),
        weekdays: BookingSlotService.getWeekdays(),
        bookingSlotToCreate: {
          slotBeginHour: '09',
          slotBeginMin: '00',
          slotEndHour: '09',
          slotEndMin: '30',
          active: false,
        },
      };
    },
    mounted() {

    },
    methods: {
      setBookingSlotDate(e) {
        this.$store.commit('booking/SET_SELECTED_BOOKING_SLOT_DATE', e);
        this.setBookingSlotId();
      },
      setBookingSlotId() {
        const weekday = this.weekdays[moment(this.selectedBookingSlotDate).weekday() -1];
        const newSlot = this.getNewSingleBookingSlot(weekday);
        this.$store.commit('booking/SET_ADHOC_SLOT', newSlot);
        this.$store.commit('booking/SET_SELECTED_BOOKING_SLOT_ID', '5c6c03f9477046693f5543cf');
      },
      updateEndSlot() {
        if(this.limitedSlot) { // limited slot, always add 30 mins
          let time = this.bookingSlotToCreate.slotBeginHour + ':' + this.bookingSlotToCreate.slotBeginMin + ':00';
          let addMinutes = moment(time, 'HH:mm:ss').add(this.max_slot_length, 'minutes').format('HH:mm');
          let split = addMinutes.split(':');

          this.bookingSlotToCreate.slotEndHour = split[0];
          this.bookingSlotToCreate.slotEndMin = split[1];
        } else {
          this.checkEndSlotValid();
        }
      },
      checkEndSlotValid() {
        let startTime = this.bookingSlotToCreate.slotBeginHour + ':' + this.bookingSlotToCreate.slotBeginMin + ':00';
        let endTime = this.bookingSlotToCreate.slotEndHour + ':' + this.bookingSlotToCreate.slotEndMin + ':00';

        startTime = moment(startTime, 'HH:mm:ss');
        endTime = moment(endTime, 'HH:mm:ss');

        let duration = moment.duration(endTime.diff(startTime));
        let minutesLeft = duration.asMinutes();

        let negative = Math.sign(minutesLeft) === -1;

        this.$store.commit('booking/SET_END_DATE_VALID',
          !negative && (minutesLeft <= this.max_slot_length));

        this.setBookingSlotId();
      },
      increaseTimeSlot(prop, array, callback){
        let value = this.bookingSlotToCreate[prop];
        let max = array.length - 1;
        let index = array.indexOf(value);

        if(index < max) {
          this.bookingSlotToCreate[prop] = array[index + 1]; // first element
        } else {
          this.bookingSlotToCreate[prop] = array[0];
        }

        if(callback){
          callback();
        }
      },
      decreaseTimeSlot(prop, array, callback){
        let value = this.bookingSlotToCreate[prop];
        let max = array.length - 1;
        let index = array.indexOf(value);

        if(index === 0) {
          this.bookingSlotToCreate[prop] = array[max]; // first element
        } else {
          this.bookingSlotToCreate[prop] = array[index - 1];
        }

        if(callback){
          callback();
        }
      },
      getNewSingleBookingSlot(weekDay) {
        const start = `${this.bookingSlotToCreate.slotBeginHour}:${this.bookingSlotToCreate.slotBeginMin}`;
        const end = `${this.bookingSlotToCreate.slotEndHour}:${this.bookingSlotToCreate.slotEndMin}`;

        return {
          day_of_week: weekDay,
          slot_begin: start,
          slot_end: end,
        };
      },
    },
  };
</script>
